export default __webpack_public_path__ + "static/media/MS00101.f905009e.mp3";